import { 
	LOGIN_REFRESH_FAILURE, 
	LOGIN_REFRESH_REQUEST, 
	LOGIN_REFRESH_SUCCESS 
} from "@/constants";
import { IToken } from "@/types/models/hooks";
import { 
	define_token, 
	undefine_token, 
	validate_token
} from "@/utils/http_functions";
import { decodeJwt } from "jose";
import { Dispatch } from "redux";

export function loginRefreshRequest() {
	return {
			type: LOGIN_REFRESH_REQUEST
	};
}

export function loginRefreshSuccess(token: string) {
	define_token(token);
	const decodedToken = decodeJwt<IToken>(token);
	
	return {
			type: LOGIN_REFRESH_SUCCESS,
			payload: {
				token,
				tokenVals: decodedToken
			},
	};
}

export function loginRefreshFailure({statusCode = 403, statusText = '', statusType = "error"}) {
undefine_token();

return {
	type: LOGIN_REFRESH_FAILURE,
	payload: {
		statusCode,
		statusText, // ?? errorMessageHandler(status), TODO?
		statusType,
	},
};
}

export function loginRefresh(token: string) {
return (dispatch: Dispatch) => {
	dispatch(loginRefreshRequest());
	validate_token(token)
	.then(({data, status}) => {
		if (data.token_is_valid) {
			dispatch(loginRefreshSuccess(token));
		} else {
			dispatch(loginRefreshFailure({statusCode: status, statusType: "warning"}));
		}
	})
	.catch(error => {
		// Token probably not valid or has expired so we remove it
		dispatch(loginRefreshFailure({statusCode: error.status, statusType: "warning"}));
	});
	}
}